export default "__VITE_ASSET__DUDaL2ma__"